/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    numberTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.#',
        defaultMessage: '#'
    },
    yearTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.Year',
        defaultMessage: 'Year'
    },
    manufacturerTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.Manufacturer',
        defaultMessage: 'Manufacturer'
    },
    serialNumberTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.Serial Number',
        defaultMessage: 'Serial Number'
    },
    valueTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.Value ($)',
        defaultMessage: 'Value ($)'
    },
    forMainBoatOrTenderTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.For main boat or tender',
        defaultMessage: 'For main boat or tender'
    },
    addTrailer: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.Add Trailer',
        defaultMessage: 'Add Trailer'
    },
    add: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.AddButton',
        defaultMessage: 'Add'
    },
    removeTrailer: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.Trailer.Remove Trailer',
        defaultMessage: 'Removed Trailer {manDesc}'
    },
});